module.exports = "attribute mediump vec2 aVertexPosition;\n\nuniform mediump mat4 proj_inv;\n\nvarying mediump vec3 vDirection;\n\nvoid main(void) {\n  gl_Position = vec4(aVertexPosition, 1.0, 1.0);\n  mediump vec4 projective_direction = proj_inv * gl_Position;\n  vDirection = projective_direction.xyz / projective_direction.w;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./source/webgl/vertex.glsl
 ** module id = 28
 ** module chunks = 0
 **/